import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import styles from 'src/screen/login-screen/login-screen.module.scss'

export const LoginBannerIpl = (): React.ReactElement => {
  return (
    <Container className={`ms-0 me-0 ${styles.imgBackIpl}`}>
      <Row className="px-lg-1 pt-5 pb-5">
      </Row>
      <Row className="px-lg-1 pt-5 py-3">
        <Col lg={1}></Col>
        <Col lg={10} className="p-0">
          <h1 className="ipl-color-primary pb-3">
            <b className="font-44">Hauliers</b>
          </h1>
          <p className="color-white fs-4">
            <h3 className="font-18">
            In one place you can find new work, grow your
              <br /> business, get access to 'green', sustainable <br />
              business, and earn great rewards. Everything <br /> 
              ready to fit your fleet and ready to go. No <br /> hidden charges, no fees.
            </h3>
          </p>
        </Col>
        <Col lg={1}></Col>
      </Row>
      <Row className="px-lg-1 py-3">
        <Col lg={1}></Col>
        <Col lg={10} className="p-0">
          <p className="color-white fs-4">
            <b className="font-18">
              INCREASE YOUR REVENUES,
              <br />
              STREAMLINE YOUR SUPPLY CHAIN.
            </b>
          </p>
        </Col>
        <Col lg={1}></Col>
      </Row>
    </Container>
  )
}
